import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ImpuestosComplemento = ({ impuestos }) => {
    return (
        <>
            {/* Impuestos TrasladosDR */}
            <Card className="mb-3 border">
                <Card.Header className="bg-light py-2">
                    <strong>Impuestos TrasladosDR</strong>
                </Card.Header>
                <Card.Body className="py-2">
                    <p className="small mb-0">
                        <span className="fw-bold">BaseDR:</span> ${impuestos?.BaseDR}
                        <span className="fw-bold ms-3">IVA Tasa:</span> {impuestos?.ivaTasaDR}
                        <span className="fw-bold ms-3">ImporteDR:</span> ${impuestos?.ImporteDR}
                    </p>
                </Card.Body>
            </Card>

            {/* Impuestos TrasladosP */}
            <Card className="mb-3 border">
                <Card.Header className="bg-light py-2">
                    <strong>Impuestos TrasladosP</strong>
                </Card.Header>
                <Card.Body className="py-2">
                    <p className="small mb-0">
                        <span className="fw-bold">BaseP:</span> ${impuestos?.BaseP}
                        <span className="fw-bold ms-3">IVA Tasa:</span> {impuestos?.ivaTasaP}
                        <span className="fw-bold ms-3">ImporteP:</span> ${impuestos?.ImporteP}
                    </p>
                </Card.Body>
            </Card>
        </>
    );
};

ImpuestosComplemento.propTypes = {
    impuestos: PropTypes.shape({
        BaseDR: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        ImporteDR: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        ivaTasaDR: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        BaseP: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        ImporteP: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        ivaTasaP: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
};

export default ImpuestosComplemento;
